import React from 'react'
import { FormattedMessage } from 'react-intl'
import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import Caption from 'LuxKit/Typography/Caption'

interface Props {
  startLocation?: string | null
  endLocation?: string | null
  size?: 'small' | 'medium' | 'large'
}

function BookmarkLocationWithStartAndEnd({
  startLocation,
  endLocation,
  size = 'large',
}: Props) {
  return (
    <CaptionTextBlock variant={size} lineClamp={2}>
      <FormattedMessage
        id="iyvRijBIOs"
        defaultMessage="Starts in <bold>{startLocation}</bold>, Ends in <bold>{endLocation}</bold>"
        description="Bookmark card showing tour start and end locations in bold"
        values={{
          startLocation,
          endLocation,
          bold: (chunks) => <Caption as="span" weight="bold" variant={size}>{chunks}</Caption>,
        }}
      />
    </CaptionTextBlock>
  )
}

export default BookmarkLocationWithStartAndEnd
